import { assert } from '../..';
import { withValidation } from '../../validations';
const ariaHaspopupSDKFactory = ({ setProps, props }) => ({
    get hasPopup() {
        return props.ariaAttributes?.haspopup;
    },
    set hasPopup(value) {
        setProps({
            ariaAttributes: {
                ...props.ariaAttributes,
                haspopup: assert.isNil(value) ? undefined : String(value),
            },
        });
    },
});
export const createAriaHaspopupSDK = withValidation(ariaHaspopupSDKFactory, {
    type: ['object'],
    properties: {
        hasPopup: {
            type: ['string', 'boolean'],
            enum: ['false', 'true', 'menu', 'dialog', 'grid', 'listbox', 'tree'],
        },
    },
});
//# sourceMappingURL=ariaHaspopupSDKFactory.js.map